export default "__VITE_ASSET__B9JBNr_x__"